module.exports = __webpack_public_path__ + "img/equipo_de_prueba.3a68a790.jpg";